<template>
    <div>
        <div class="flex items-center px-2 py-3 sm:px-4">
            <div class="flex min-w-0 flex-1 items-center">
                <div class="flex-shrink-0">
                    <div class="flex items-center justify-center rounded-full border-2 border-gray-300 bg-white p-3">
                        <UserIcon class="border-gray-150 w-6" />
                    </div>
                </div>
                <div class="min-w-0 flex-1 items-center px-4 md:grid md:grid-cols-3 md:gap-4">
                    <div>
                        <p class="text-sm font-medium text-gray-900">
                            <span class="truncate">{{
                                beneficialOwner.first_name + ' ' + beneficialOwner.last_name
                            }}</span>
                        </p>
                        <p class="mt-2 flex items-center text-sm text-gray-500">
                            <MailIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                            <span class="truncate">{{ beneficialOwner.email }}</span>
                        </p>
                    </div>
                    <div class="hidden divide-y md:flex">
                        <AccountLegalSignaturesPreview
                            :signatures="beneficialOwner.signatures"></AccountLegalSignaturesPreview>
                    </div>
                    <div class="flex justify-end">
                        <BaseButtonMuted
                            v-if="beneficialOwner.id"
                            :disabled="removing || beneficialOwnerEditingIsLocked()"
                            class="self-end"
                            @click="remove()"
                            ><MinusCircleIcon class="-ml-1 mr-2 w-4 text-red-500"></MinusCircleIcon
                            >{{ $t('beneficial_owner.remove') }}</BaseButtonMuted
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import AccountLegalSignaturesPreview from '../AccountLegalSignaturesPreview.vue'
import { MailIcon } from '@heroicons/vue/solid'
import { UserIcon } from '@heroicons/vue/outline'
import { MinusCircleIcon } from '@heroicons/vue/outline'

import { deleteBeneficialOwner } from '../../../../utilities/api'
import {
    beneficialOwnerEditingIsLocked,
    useLegalAccountDataState,
} from '../../../../utilities/account/useAccountDataLegal'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { ref } from 'vue'

const props = defineProps<{
    beneficialOwner: any
}>()

const removing = ref(false)

async function remove() {
    removing.value = true
    await deleteBeneficialOwner(props.beneficialOwner.id)
    await useLegalAccountDataState().fetchAccountData()
    removing.value = false
}
</script>

<style scoped></style>
